import { render, staticRenderFns } from "./pc-webinar-detail.vue?vue&type=template&id=0b3d9d34"
import script from "./pc-webinar-detail.vue?vue&type=script&lang=js"
export * from "./pc-webinar-detail.vue?vue&type=script&lang=js"
import style0 from "./pc-webinar-detail.vue?vue&type=style&index=0&id=0b3d9d34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports